const ITEMS = [
  "BUILT BY BATZENMODZ",
  "FROM IDEA TO RELEASE",
  "RAAVAFORGE STUDIO",
  "PC TOOLS & UTILITIES",
  "PS3 MOD MENUS",
  "RTM DEVELOPMENT",
  "ONE HOME FOR EVERY PROJECT",
  "ALWAYS EVOLVING",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-white/10 py-5 overflow-hidden bg-black/45 backdrop-blur-md" data-testid="marquee-section">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center text-xs uppercase tracking-[0.3em] text-[#A1A1AA]">
                <span className={i % 2 === 0 ? "text-[#00FF66]" : ""}>{item}</span>
                <span className="mx-8 text-[#00F0FF]">—</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
